import { selectOrganizationNodeLeaves } from 'slices/organizationHierarchy.slice';
import { useAppSelector } from 'slices/store';
import { TEInput } from '@timeedit/ui-components';

type Props = {
  selectedStandardOrganizationId: string | number | undefined | null;
  onChange: (selectedStandardOrganizationId: string | number) => void;
};

const StandardOrganizationSelector = ({
  selectedStandardOrganizationId,
  onChange,
}: Props) => {
  const eligibleStandardOrganizations = useAppSelector(
    selectOrganizationNodeLeaves
  );

  return (
    <TEInput.Select
      label="Standard organisation node"
      tooltip="Root user standard organization node"
      value={selectedStandardOrganizationId}
      onChange={(value: any) => onChange(value)}
      options={(eligibleStandardOrganizations || []).map((node) => ({
        value: node.id,
        label: node.name,
      }))}
      placeholder="Select"
      className="testid-standard-org"
    />
  );
};

export default StandardOrganizationSelector;
